var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.002,
    height: 22.001,
    viewBox: "0 0 22.002 22.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 166",
    d: "M360.089 4364.106a11 11 0 1 0 11 11 11.013 11.013 0 0 0-11-11zm0 20.06a9.06 9.06 0 1 1 9.06-9.059 9.07 9.07 0 0 1-9.06 9.059z",
    transform: "translate(-349.088 -4364.106)",
    style: {
      fill: "#fd7121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 167",
    d: "M363.007 4379.3a.879.879 0 0 0 .88-.879v-6.335a.88.88 0 0 0-1.76 0v6.335a.879.879 0 0 0 .88.879z",
    transform: "translate(-352.006 -4365.694)",
    style: {
      fill: "#fd7121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 168",
    d: "M362.987 4383.038a.948.948 0 1 0 .948.948.949.949 0 0 0-.948-.948z",
    transform: "translate(-351.986 -4368.343)",
    style: {
      fill: "#fd7121"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeInfoIcon);
export default __webpack_public_path__ + "static/media/orange-info-icon.c7e14a013a43ea4670f3a273459ecc51.svg";
export { ForwardRef as ReactComponent };